import { setPreferredExperience } from '@/console/host/experience-storage';
import { ExperienceId } from '@/console/host/experience.types';
import { EXPERIENCE_PARAM } from '@/console/host/resolve-experience';

export const switchExperience = (experience: ExperienceId) => {
  setPreferredExperience(experience);

  const url = new URL(window.location.href);

  url.searchParams.delete(EXPERIENCE_PARAM);

  window.location.assign(url.toString());
};

export const buildExperienceUrl = (
  pathname: string,
  experience: ExperienceId,
) => {
  const [path, existingSearch] = pathname.split('?');
  const search = new URLSearchParams(existingSearch);

  search.set(EXPERIENCE_PARAM, experience);

  return `${path}?${search.toString()}`;
};

export const openPathInOtherExperience = (pathname: string) =>
  window.location.assign(buildExperienceUrl(pathname, 'classic'));
